import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getSector } from '../../services/sectors'

export const GET_SECTOR = 'GET_SECTOR'
export const GET_SECTOR_ERROR = 'GET_SECTOR_ERROR'
export const GET_SECTOR_SUCCESS = 'GET_SECTOR_SUCCESS'
export const onGetSector = makeActionCreator(GET_SECTOR)
export const onGetSectorError = makeActionCreator(GET_SECTOR_ERROR, 'payload')
export const onGetSectorSuccess = makeActionCreator(GET_SECTOR_SUCCESS, 'payload')
export const onGetSectorThunk = payload => async dispatch => {
  dispatch(onGetSector())

  try {
    if (!payload.id) {
      throw customizeError({ reason: 'INVALID_SECTOR_ERROR' })
    }

    const { data } = await getSector({ sectorId: payload.id, year: payload.year })
    return dispatch(
      onGetSectorSuccess({
        amount: data?.payload?.amountAnualCLP || 0,
        amountUSD: data?.payload?.amountAnualUSD || 0,
        biddings: data?.payload?.quantityLicSectorAnnual || 0,
        id: payload.id,
        name: data?.payload?.sector || '',
        orders: data?.payload?.quantityOCAnnual || 0,
        organizations: data?.payload?.quantityOrgTotal || 0,
        purchases: data?.payload?.quantityOrgAnnual || 0
      })
    )
  } catch (error) {
    return dispatch(onGetSectorError({ error }))
  }
}
